"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _updateProgress = _interopRequireDefault(require("./utils/updateProgress"));

var _root = _interopRequireDefault(require("./style/root"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _wrapper = _interopRequireDefault(require("./style/wrapper"));

var _input = _interopRequireDefault(require("./style/input"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _ownerDocument = _interopRequireDefault(require("../../utils/ownerDocument"));

var _progress = _interopRequireDefault(require("./style/progress"));

var _bar = _interopRequireDefault(require("./style/bar"));

var _pointerWrapper = _interopRequireDefault(require("./style/pointerWrapper"));

var _pointer = _interopRequireDefault(require("./style/pointer"));

var _hint = _interopRequireDefault(require("./style/hint"));

var _hintTriangle = _interopRequireDefault(require("./style/hintTriangle"));

var _INumber = _interopRequireDefault(require("../../common/iObjects/INumber"));

var _calculateCurrentProgress = _interopRequireDefault(require("./utils/calculateCurrentProgress"));

var _userAgent = _interopRequireDefault(require("../../common/userAgent.0.0.3"));

var Interval = _react["default"].forwardRef(function (_ref, ref) {
  var elementRef = _ref.elementRef,
      roundingAccuracy = _ref.roundingAccuracy,
      end = _ref.end,
      start = _ref.start,
      step = _ref.step,
      onChange = _ref.onChange,
      className = _ref.className,
      style = _ref.style,
      theme = _ref.theme,
      value = _ref.value,
      hint = _ref.hint,
      disabled = _ref.disabled;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var progress = (0, _react.useRef)(null);
  var input = (0, _react.useRef)(null);
  var handleDragEnd = (0, _react.useCallback)(function () {
    return setFocused(false);
  }, []);
  var handleDragStart = (0, _react.useCallback)(function () {
    if (!disabled) {
      setFocused(true);
    }
  }, [disabled]);

  var update = function update(event) {
    return (0, _updateProgress["default"])({
      event: event,
      progressBar: progress.current,
      step: step,
      start: start,
      end: end,
      roundingAccuracy: roundingAccuracy,
      onChange: onChange,
      input: input.current
    });
  };

  var handleMouseMove = (0, _react.useCallback)(function (event) {
    if (focused) {
      update(event);
    }
  }, [focused]);
  var handleProgressClick = (0, _react.useCallback)(function (event) {
    if (!disabled) {
      update(event);
    }
  }, [disabled]); // add refs

  (0, _react.useEffect)(function () {
    if (ref) {
      ref.current = input.current;
    }

    if (typeof elementRef === 'function') {
      elementRef(input.current);
    } else if ((0, _typeof2["default"])(elementRef) === 'object') {
      elementRef.current = input.current;
    }

    return function () {
      if (ref) {
        ref.current = null;
      }

      if (typeof elementRef === 'function') {
        elementRef(null);
      } else if ((0, _typeof2["default"])(elementRef) === 'object') {
        elementRef.current = null;
      }
    };
  }, [ref, elementRef]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style]);
  var progressStyle = (0, _react.useMemo)(function () {
    return {
      width: (0, _calculateCurrentProgress["default"])({
        value: new _INumber["default"](value),
        start: start,
        end: end
      }) + '%'
    };
  }, [value, start, end]);
  var hintContent = (0, _react.useMemo)(function () {
    if (hint && focused && value) {
      return _react["default"].createElement(_hint["default"], {
        theme: memoTheme
      }, _react["default"].createElement(_hintTriangle["default"], {
        theme: memoTheme
      }), value);
    } else {
      return null;
    }
  }, [hint, focused, value, memoTheme]);
  return _react["default"].createElement(_root["default"], {
    theme: memoTheme,
    className: className
  }, _react["default"].createElement(_wrapper["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_input["default"], {
    type: "text",
    value: value,
    onChange: onChange,
    ref: input
  }), _react["default"].createElement(_reactEventListener["default"], {
    target: (0, _ownerDocument["default"])(progress.current).querySelector('body'),
    onMouseMove: _userAgent["default"].browser.isMobileDevice ? undefined : handleMouseMove,
    onTouchMove: _userAgent["default"].browser.isMobileDevice ? handleMouseMove : undefined,
    onMouseUp: _userAgent["default"].browser.isMobileDevice ? undefined : handleDragEnd,
    onTouchEnd: _userAgent["default"].browser.isMobileDevice ? handleDragEnd : undefined
  }), _react["default"].createElement(_progress["default"], {
    theme: memoTheme,
    onClick: handleProgressClick,
    ref: progress
  }, _react["default"].createElement(_bar["default"], {
    theme: memoTheme,
    disabled: disabled,
    focused: focused,
    style: progressStyle
  }, _react["default"].createElement(_pointerWrapper["default"], {
    theme: memoTheme
  }, _react["default"].createElement(_pointer["default"], {
    type: "button",
    disabled: disabled,
    focused: focused,
    theme: memoTheme,
    onMouseDown: _userAgent["default"].browser.isMobileDevice ? null : handleDragStart,
    onTouchStart: _userAgent["default"].browser.isMobileDevice ? handleDragStart : null
  }, hintContent))))));
});

Interval.propTypes = {
  onChange: _propTypes["default"].func,
  onDrag: _propTypes["default"].func,
  start: _propTypes["default"].number,
  step: _propTypes["default"].number,
  end: _propTypes["default"].number,
  roundingAccuracy: _propTypes["default"].number,
  hint: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default inline-block
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.gutter / 2 + 'px'
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter * 20 + 'px'
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.gutter / 2 + 'px'
     */
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.elDivider
     */
    background: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    selectedBackground: _propTypes["default"].string,

    /**
     * @default palette.elAccent
     */
    pointerBackground: _propTypes["default"].string,

    /**
     * @default 50%
     */
    pointerBorderRadius: _propTypes["default"].string,

    /**
     * @default palette.elAccentDark
     */
    focusPointerBackground: _propTypes["default"].string,

    /**
     * @default palette.elAccentDark
     */
    focusSelectedBackground: _propTypes["default"].string
  })
};
Interval.defaultProps = {
  onChange: null,
  onDrag: null,
  start: 0,
  step: 0,
  end: 100,
  roundingAccuracy: 3
};
var _default = Interval;
exports["default"] = _default;